//libs
import { useState } from 'react';
import classNames from 'classnames';

//types
import { IFederalNetworkSearchProps } from '../types/IFederalNetworkSearch';

export default function FederalNetworkSearch({
    features,
    setSearch,
}: IFederalNetworkSearchProps) {
    const [selected, setSelected] = useState<string[]>([]);
    
    const toggleFeature = (value: string[]) => {
        setSearch(value);
    };

    return (
        <ul className="destributors-filter-block__list destributors-filter-block-list">
            {features.map(({ id, name, value }) => {
                const classesBtn = classNames(
                    'destributors-filter-block-item__btn', 
                    {
                        'destributors-filter-block-item__btn--active': 
                            selected.length === value.length && selected.every((s, i) => s === value[i]),
                    }
                );

                return (<li
                    className="destributors-filter-block-item"
                    key={id}
                    onClick={() => {
                        const isSelected = selected.length === value.length && selected.every((s, i) => s === value[i]);
                        
                        setSelected(isSelected ? [] : value);
                        toggleFeature(isSelected ? [] : value);
                    }}
                >
                    <button className={classesBtn}>{name}</button>
                </li>);
            })}
        </ul>
    );
};